import "./TextArea.css"
import { useSelector, useDispatch } from "react-redux"
import { setText } from "../../actions"


const TextArea = () => {

    const text = useSelector(state => state.text)
    const dispatch = useDispatch()

    const handleChange = (e) => {
        if (e.target.value.length > 60){
            return null
        }
        dispatch(setText(e.target.value))
    }

    return(
        <div className="TextArea">
            <textarea value={text} onChange={(e) => {handleChange(e)}} placeholder="How do you feel about the event?"></textarea>
            <div className="wordLimit">{text ? text.length:0}/60</div>
        </div>
    )
}

export default TextArea